import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOMeta from '@/components/base/SEOMeta';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '寸止挑战训练中心',
  url: 'https://cunzhitiaozhan.com/',
  description: '寸止挑战是一项考验极限控制力与专注度的热门挑战项目。深度解析规则玩法、技巧训练、常见误区与进阶方法。',
  inLanguage: 'zh-CN',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '寸止挑战训练中心',
  url: 'https://cunzhitiaozhan.com/',
  description: '专注于极限控制力与专注度训练的专业平台',
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <SEOMeta
        title="寸止挑战 - 极限控制力测试全攻略 | 入门教程·技巧训练·进阶攻略"
        description="寸止挑战是一项考验极限控制力与专注度的热门挑战项目。本页深度解析寸止挑战的规则玩法、技巧训练、常见误区与进阶方法，帮助挑战者突破自我极限，掌握真正的寸止精髓，适合新手入门与高手进阶。"
        keywords="寸止挑战,寸止挑战技巧,寸止挑战规则,寸止挑战训练方法,寸止挑战入门教程,极限控制力训练,寸止挑战进阶攻略"
        canonicalUrl="https://cunzhitiaozhan.com/"
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturedArticles />
        <CategoryGrid />
        <LatestArticles />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}